// extracted by mini-css-extract-plugin
export default {"card":"Card_card__XnxCQ","btnn":"Card_btnn__kdl3B"};